import { render } from "./AssignProjectPopup.vue?vue&type=template&id=484405ad&scoped=true&ts=true"
import script from "./AssignProjectPopup.vue?vue&type=script&lang=ts"
export * from "./AssignProjectPopup.vue?vue&type=script&lang=ts"

import "./AssignProjectPopup.vue?vue&type=style&index=0&id=484405ad&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484405ad"]])

export default __exports__